//include 2
window.pixelpoint.getElementDimensions = function($element) {
    var height = $element.height();
    var width = $element.width();
    if (height == 0) {
        var $clone = $element.clone();

        if ($element.parents('.tabs-content').length) {
            $clone.addClass("tabs-content");
        }

        $clone.removeClass("collapsed");      
        $("body").append($clone);

        $clone.attr("style", "position: absolute !important; visibility: hidden !important; display: block !important");

        $clone.find("*").each(function () {
            $(this).removeClass("collapsed");
            if (!$(this).is(":visible")) {
                $(this).attr("style", "display: block !important;");
            }
        });

        width = $clone.outerWidth(true);
        height = $clone.outerHeight(true);
        $clone.remove();
    }
    return {
        width: width,
        height: height
    };
}